import { jsx as _jsx } from "react/jsx-runtime";
import { SourceSuggestionButton } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SourceSuggestionButton.js';
import { SourceSuggestionPremiumData } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SourceSuggestionPremiumData.js';
import { useApiSource } from '#pplx/frontend/apps/ask/sources/hooks/useApiSource.js';
import { useSourceActivity } from '#pplx/frontend/apps/ask/user-settings/hooks/useSourceActivity.js';
import { memo, useCallback } from 'react';
export const SourceSuggestion = memo(function SourceSuggestion({ source, connected, iconOnly, onClick, }) {
    const { trackSourceActivity } = useSourceActivity();
    // Resolves from the already-cached source lists without mounting another
    // /rest/sources list query variant; only connected chips need the premium
    // routing lookup.
    const { source: apiSource } = useApiSource({
        sourceId: source,
        reason: 'source-suggestion',
        enabled: connected,
    });
    const handleClick = useCallback(() => {
        if (connected) {
            trackSourceActivity(source);
        }
        onClick(source, connected);
    }, [onClick, source, connected, trackSourceActivity]);
    if (connected && apiSource && 'is_premium' in apiSource && apiSource.is_premium) {
        return (_jsx(SourceSuggestionPremiumData, { source: source, onClick: handleClick, iconOnly: iconOnly }));
    }
    return _jsx(SourceSuggestionButton, { source: source, onClick: handleClick, iconOnly: iconOnly });
});
//# sourceMappingURL=SourceSuggestion.js.map